interface TreeNode {
  key: string;
  name: string;
  children?: TreeNode[];
}

export const findParent = (
  key: string,
  nodes: TreeNode[],
  parent: TreeNode | null = null,
): TreeNode | null => {
  for (const node of nodes) {
    if (node.key === key) {
      return parent;
    }
    if (node.children) {
      const result = findParent(key, node.children, node);
      if (result) {
        return result;
      }
    }
  }
  return null;
};
